import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PureComponent } from 'react';
import { CORE_COMPONENT, CREATE_COMPONENT } from "./symbols.mjs";

/** @deprecated */

var Root = undefined;
export { Root };

/** @deprecated */
var RootComponent = /*#__PURE__*/function (_PureComponent) {
  _inherits(RootComponent, _PureComponent);
  var _super = _createSuper(RootComponent);
  function RootComponent() {
    var _this;
    _classCallCheck(this, RootComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "Root", undefined);
    _defineProperty(_assertThisInitialized(_this), "isControlled", false);
    return _this;
  }
  _createClass(RootComponent, [{
    key: "handlers",
    get: function get() {
      return {};
    }
  }, {
    key: "asProps",
    get: function get() {
      return {};
    }
  }]);
  return RootComponent;
}(PureComponent);
export var Component = RootComponent;
/** @deprecated */

export var Intergalactic;
(function (_Intergalactic) {
  var InternalTypings;
  (function (_InternalTypings) {})(InternalTypings || (InternalTypings = _Intergalactic.InternalTypings || (_Intergalactic.InternalTypings = {})));
})(Intergalactic || (Intergalactic = {}));
export var wrapIntergalacticComponent = function wrapIntergalacticComponent(wrapper) {
  return wrapper;
};
//# sourceMappingURL=Component.mjs.map